import React from 'react';
import { useStyles } from './FAQItem-style';
import { ChevronRightOutlined } from '@next-common/material-ui-icons';
import { colorPalette } from '../../colorPalette';
const FAQItemDefaultProps = {
    item: {
        id: 0,
        title: '',
        slug: '',
    },
};
export const FAQItem = ({ item, onClick } = FAQItemDefaultProps) => {
    const s = useStyles();
    return (React.createElement("div", { className: s.faqItem },
        React.createElement("button", { type: "button", className: s.btn, key: item.id, onClick: onClick },
            React.createElement("span", { className: s.modalContentLink }, item.title),
            React.createElement(ChevronRightOutlined, { style: {
                    width: "14px", height: "20px", color: `${colorPalette.red800}`
                } }))));
};
